// Centralized digital-support contact details. Reference these constants from any component or
// service that surfaces support contact info so a future change (number, mailbox) lands in one place.
export const SUPPORT_EMAIL: string = 'digitalsupport@lekkerland.de';
export const SUPPORT_PHONE_LABEL: string = '02234 / 9314-444';
export const SUPPORT_PHONE_HREF: string = '+4922349314444';
